import styled from "styled-components";

const Loading = styled.div`
  background-color: inherit;
  padding: 20px;
  text-align: center;
  width: 100%;
`;

Loading.displayName = "SecondaryButton";

export { Loading };
